import useSelectedShop from './useSelectedShop';
import useFirewall from './useFirewall';

function usePermissionAccess(permission) {
  const shop = useSelectedShop();
  const firewall = useFirewall(shop.id);
  return firewall.hasAccess(permission);
}

export default usePermissionAccess;